/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Bluefin from './Bluefin/index'
import No from './No/index'
import Payabli from './Payabli/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderCaptureMethod/Content/TestInfo/Content/Content",
  innerRef,
  left,
  top
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let paymentProviderValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'provider',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: paymentProviderValueData,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 ref={innerRef}
 style={{'--l-1-Z1Yf8zk': typeof left === 'number' ? `${left}px` : left,'--t-2-Z1Yf8zk': typeof top === 'number' ? `${top}px` : top,'--pt-3-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-4-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Payabli'}>
<Payabli
  viewPath={`${viewPath}/Payabli`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Bluefin'}>
<Bluefin
  viewPath={`${viewPath}/Bluefin`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}